<template>
    <b-modal id="msisdn-overview" v-model="display" title="Detalle de línea" :hide-footer="!isFullLoaded">
        <!-- <div class="p-3"> -->
            <account-saldo-page :msisdn="numero.msisdn" hide-historial-button @success="handleSuccess" @fail="handleFail"/>
            <msisdn-recharge-history ref="msisdnRechargeHistory" class="mt-2" :msisdn="numero.msisdn" hideHistorialButton/>
        <!-- </div> -->
        <template #modal-footer>
            <b-button-group>
                <b-button variant="outline-danger" @click="askForUnsubscribe" v-if="isActive && !isByPass">
                    Cancelar suscripción <i class="fa fa-times"></i>
                </b-button>
                <b-button class="pl-3" variant="info" @click="$refs.msisdnRechargeHistory.open" v-if="isActive">
                    Historial
                </b-button>
                <b-button variant="primary" @click="redirectToRecharge">
                    Recargar <span class="imoon-credit-card"></span>
                </b-button>
            </b-button-group>
        </template>


    </b-modal>
</template>

<script>
import MsisdnRechargeHistory from './../daniel/msisdnRechargeHistory.vue';
import AccountSaldoPage from './account-saldo-page'
import { confirmFirst, notify } from '@/js/utils';
import { portalCautivo as portalCautivoOpener } from '@/js/apiConfig'

const components = { AccountSaldoPage, MsisdnRechargeHistory };

export default {
    name: 'msisdnOverview',
    components,
    data: () => {
        return {
            isByPass:false,
            isFullLoaded: false,
            display: false,
            numero: {}
        }
    },
    computed: {
        isActive() {
            return ((this.isByPass) || (this.numero && this.numero.estatus_suscripcion == 'Activa' && this.numero.stripe_suscripcion_id))
        }
    },
    methods: {
        redirectToRecharge() {
            portalCautivoOpener(this.numero.msisdn)
        },
        setByPass(byPass) {
            this.isByPass = (parseInt(byPass) == 1)? true : false
        },
        async askForUnsubscribe() {
            try {
                let resp = await confirmFirst('¿Está seguro de cancelar la suscripción?')
                if (resp) {
                    let response = await axios.delete('suscripcion/delete/' + this.numero.usuarios_suscripciones_id, { msisdn: this.numero.msisdn })
                    notify(response.msg, response.class)
                    if(response.status) {
                        this.$emit('refresh')
                        this.display = false
                    }
                }
            } catch(e) {
                console.error(e)
            }
        },
        /**
         * Se ejecuta encuanto se obtiene la información de la línea
         */
         handleSuccess(response) {
            this.isFullLoaded = true;
        },
        /**
         * Se ejecuta en caso de error
         */
        handleFail(error) {
            this.isFullLoaded = false;
            console.error('handleFail', error)
        },
        /**
         * Muestra el modal...
         */
        open(numero) {
            this.display = true
            this.isFullLoaded = false;
            console.log('open', numero)
            this.numero = numero
        }
    }
}

</script>